import { keyframes } from 'styled-components';

const bounceIn = keyframes(["0%{opacity:0;transform:scale(.3);}50%{opacity:1;transform:scale(1.05);}70%{transform:scale(.9);}100%{opacity:1;transform:scale(1);}"]);

const bounceOut = keyframes(["0%{transform:scale(1);}25%{transform:scale(.95);}50%{opacity:1;transform:scale(1.1);}100%{opacity:0;transform:scale(.3);}"]);

const fadeIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);

const fadeOut = keyframes(["0%{opacity:1;}100%{opacity:0;}"]);

var index = {
  bounceIn,
  bounceOut,
  fadeIn,
  fadeOut
};

export { index as default };
